import { enhancedApi } from '@store/generated/patients';

/**
 * Feature-specific tag types for patient documents cache management
 */
const PATIENT_DOCUMENTS_TAG_TYPES = [
  'PatientDocument',
  'PatientDocumentsList',
] as const;

/**
 * Patient Documents API - extends the generated OpenAPI client
 * This ensures we're using generated types and endpoints
 * while maintaining feature-specific customization
 */
export const patientDocumentsApi = enhancedApi
  .enhanceEndpoints({
    addTagTypes: PATIENT_DOCUMENTS_TAG_TYPES,
    endpoints: {
      // Enhance the patient documents list endpoint with proper caching
      getV2ProviderPatientDocumentsByPatientIdList: {
        providesTags: (result, _error, { pathPatientId }) =>
          result
            ? [
                ...result.items.map(item => ({
                  type: 'PatientDocument' as const,
                  id: item.document_id,
                })),
                { type: 'PatientDocumentsList' as const, id: pathPatientId },
              ]
            : [{ type: 'PatientDocumentsList', id: pathPatientId }],
      },
    },
  });

// Export hooks with user-friendly names only
export const {
  useGetV2ProviderPatientDocumentsByPatientIdListQuery: useGetPatientDocumentsQuery,
  useGetV2ProviderPatientDocumentsByDocumentIdDownloadUrlQuery: useGetDocumentDownloadUrlQuery,
  useLazyGetV2ProviderPatientDocumentsByDocumentIdDownloadUrlQuery: useLazyGetDocumentDownloadUrlQuery,
} = patientDocumentsApi;

